export function truncate  (fullStr, strLen, separator) {
    if (fullStr.length <= strLen) return fullStr;
  
    separator = separator || '...';
  
    var sepLen = separator.length,
        charsToShow = strLen - sepLen,
        frontChars = Math.ceil(charsToShow/2),
        backChars = Math.floor(charsToShow/2);
  
    return fullStr.substr(0, frontChars) + 
           separator + 
           fullStr.substr(fullStr.length - backChars);
};
  
export function convertLargeCurrency(labelValue) {
   
    // Twelve Zeroes for Trillions
    return Math.abs(Number(labelValue)) >= 1.0e+12
    
      ? (Math.abs(Number(labelValue)) / 1.0e+12).toFixed(2) + " T"
   // Nine Zeroes for Billions
      : Math.abs(Number(labelValue)) >= 1.0e+9
      ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(2) + " B"
    // Six Zeroes for Millions 
      : Math.abs(Number(labelValue)) >= 1.0e+6
      ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + " M"
    // Three Zeroes for Thousands
      : Math.abs(Number(labelValue)) >= 1.0e+3
      ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(2) + " K"
  
      : Math.abs(Number(labelValue));
  
  }
  

  export function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }
  